import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const servicePillars = [
    {
        icon: (
            <svg className="h-12 w-12 text-lochmara-blue transition-transform duration-300 group-hover:scale-110" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2a4 4 0 018 0v2M5 10a7 7 0 0114 0v2a7 7 0 01-14 0v-2z" /></svg>
        ),
        title: 'Healthcare & Medical Services',
        desc: 'Comprehensive care through The Great Emmanuel Hospital Limited, serving rural communities and driving sustainable development.',
        details: [
            'Outpatient & Inpatient Care',
            'Maternal & Child Health Care',
            'Medical Spa',
            'Diagnostic & Analytical Laboratories',
            'Telemedicine & Virtual Consultations',
            'Mobile Clinics & Emergency Response Units',
            'Elderly & Home-based Care Services',
            'Pharmaceutical Supplies, Equipment & Consumables',
            'Medical Training, Mentoring & Health Education',
            'Mobile hospital services bringing care directly to remote and underserved areas',
            'Free and subsidized medical programs focused on maternal, child, and general health',
            'Rural empowerment and employment initiatives to strengthen community capacity',
        ],
        color: 'from-blue-50 to-white',
        learn: '/great-emmanuel-hospital',
    },
    {
        icon: (
            <svg className="h-12 w-12 text-malachite-green transition-transform duration-300 group-hover:scale-110" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
        ),
        title: 'Non-Profit/Charity',
        desc: 'PureMedify Foundation: Advocating for equitable healthcare, serving underserved communities, women, and children.',
        details: [
            'Maternal health',
            'Malnutrition',
            'Infectious diseases',
            'Reproductive health',
        ],
        color: 'from-green-50 to-white',
        learn: '/contact',
    },
    {
        icon: (
            <svg className="h-12 w-12 text-brand transition-transform duration-300 group-hover:scale-110" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M12 8v8m-4-4h8" /></svg>
        ),
        title: 'Lifestyle & Consumer Wellness',
        desc: 'Organic cosmetics, spa, boutique, and grocery services for holistic well-being.',
        details: [
            'Organic Cosmetics & Beauty Products',
            'Hair, Boutique & Spa Services',
            'Grocery & Organic Stores',
        ],
        color: 'from-blue-50 to-white',
    },
    {
        icon: (
            <svg className="h-12 w-12 text-congress-blue transition-transform duration-300 group-hover:scale-110" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 7h18M3 12h18M3 17h18" /></svg>
        ),
        title: 'Technology & Logistics',
        desc: 'Digital solutions, eCommerce, logistics, infrastructure, construction, energy, and automotive services for modern businesses and communities.',
        details: [
            'Online Sales & Courier Services',
            'Facility Management',
            'Payment Systems & Integration',
            'Import/Export Operations',
            'Warehousing & Distribution',
            'Infrastructure & Construction',
            'Energy Solutions',
            'Automotive Services',
        ],
        color: 'from-blue-50 to-white',
    },
    {
        icon: (
            <svg className="h-12 w-12 text-malachite-green transition-transform duration-300 group-hover:scale-110" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M12 8v8m-4-4h8" /></svg>
        ),
        title: 'Agro-Allied & Food Security',
        desc: 'Supporting food security and sustainable agriculture for thriving communities.',
        details: [
            'Modern Farming & Agribusiness',
            'Agro Equipment Supply',
            'Workshops on Advanced Agricultural Techniques',
            'Export/Import of Farm Products',
        ],
        color: 'from-green-50 to-white',
    },
];

const otherServices = [
    {
        title: 'Agro-Allied & Food Security',
        color: 'congress-blue',
        details: [
            'Modern Farming & Agribusiness',
            'Agro Equipment Supply',
            'Workshops on Advanced Agricultural Techniques',
            'Export/Import of Farm Products',
        ],
    },
    {
        title: 'Technology, Logistics & eCommerce',
        color: 'congress-blue',
        details: [
            'Online Sales & Courier Services',
            'Facility Management',
            'Payment Systems & Integration',
            'Import/Export Operations',
            'Warehousing & Distribution',
        ],
    },
    {
        title: 'Digital Health & Innovation',
        color: 'congress-blue',
        details: [
            'Faster diagnosis',
            'Enhanced treatment planning',
            'Better patient-care responsiveness',
            'Improved data-driven decision-making',
        ],

    },
    {
        title: 'Construction & Infrastructure',
        color: 'congress-blue',
        details: [
            'Real Estate Development',
            'Property Consulting',
            'Electrical Engineering Projects',
            'Environmental Services & Borehole Drilling',
        ],
    },
    {
        title: 'Clinical & Diagnostic Solutions',
        color: 'congress-blue',
        details: [
            'Provision of diagnostic tools and analytical services',
            'Medical device and equipment supply to facilities in need',
            'Pharmaceutical support guided by global best practices',
            'Evidence-based consultation to improve diagnosis, treatment, and workflow',
        ],
    },
    {
        title: 'Medical & Community Healthcare Services',
        color: 'congress-blue',
        details: [
            'Mobile hospital services bringing care directly to remote and underserved areas',
            'Free and subsidized medical programs focused on maternal, child, and general health',
            'Rural empowerment and employment initiatives to strengthen community capacity',
        ],
    },

    {
        title: 'Energy & Automotive',
        color: 'congress-blue',
        details: [
            'Fuel Stations & Petrochemical Marketing',
            'Diesel/Gas Sales & Distribution',
            'Automobile Spare Parts & Vehicle Repairs',
            'Logistics & Haulage',
        ],
    },
];

const quickLinks = [
    { label: 'Call an Ambulance', href: '/contact', icon: <svg className="mr-2 h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M3 14h18M5 6h14M5 18h14" /></svg> },
    { label: 'Call Mobile Clinic', href: '/contact', icon: <svg className="mr-2 h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M12 8v8m-4-4h8" /></svg> },
    { label: 'Consult a Doctor', href: '/contact', icon: <svg className="mr-2 h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" /></svg> },
    { label: 'Quick Health Assessment', href: '/contact', icon: <svg className="mr-2 h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M12 8v8m-4-4h8" /></svg> },
    { label: 'Download Mobile App', href: '/contact', icon: <svg className="mr-2 h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" /></svg> },
    { label: 'Book a Lab', href: '/contact', icon: <svg className="mr-2 h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M12 8v8m-4-4h8" /></svg> },
    { label: '24/7 Emergency Helpline', href: '/contact', icon: <svg className="mr-2 h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M3 14h18M5 6h14M5 18h14" /></svg> },
];

const Services = () => {
    const [showOther, setShowOther] = useState(false);
    return (
        <div className="flex min-h-screen w-full flex-col bg-gradient-to-br from-blue-50 to-teal-100">
            {/* Hero Section */}
            <section className="from-brand-light relative flex w-full flex-col items-center justify-center overflow-hidden bg-gradient-to-br to-blue-100 py-16 md:py-24">
                <div className="relative z-10 mx-auto max-w-3xl text-center">
                    <h1 className="animate-fade-in mb-4 font-ubuntu text-4xl font-bold text-lochmara-blue drop-shadow-lg md:text-5xl">Integrated Solutions. Unmatched Impact.</h1>
                    <p className="animate-fade-in mb-6 font-redhat text-xl text-gray-700 delay-200 md:text-2xl">PUREMEDIFY LIMITED offers a robust range of services organized into key pillars for holistic impact.</p>
                </div>
                {/* Animated Bubbles and Cross Motif */}
                <svg className="animate-float-slow absolute left-10 top-10 z-0 h-24 w-24 opacity-30" viewBox="0 0 100 100" fill="none"><circle cx="50" cy="50" r="40" fill="#0087ca" /></svg>
                <svg className="animate-float-medium absolute right-20 top-24 z-0 h-16 w-16 opacity-20" viewBox="0 0 100 100" fill="none"><circle cx="50" cy="50" r="35" fill="#00b937" /></svg>
                <svg className="animate-float-fast absolute bottom-10 left-1/2 z-0 h-20 w-20 opacity-20" viewBox="0 0 100 100" fill="none"><circle cx="50" cy="50" r="30" fill="#004487" /></svg>
                <svg className="animate-float-cross absolute bottom-16 right-10 z-0 h-16 w-16" viewBox="0 0 64 64" fill="none"><rect x="28" y="8" width="8" height="48" rx="4" fill="#0087ca" /><rect x="8" y="28" width="48" height="8" rx="4" fill="#00b937" /></svg>
                <style>{`
        @keyframes fade-in { 0% { opacity: 0; transform: translateY(40px);} 100% { opacity: 1; transform: translateY(0);} }
        .animate-fade-in { animation: fade-in 1.2s cubic-bezier(.4,0,.2,1) both; }
        .delay-200 { animation-delay: 0.2s; }
        @keyframes float-slow { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-20px); } }
        .animate-float-slow { animation: float-slow 7s ease-in-out infinite; }
        @keyframes float-medium { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-30px); } }
        .animate-float-medium { animation: float-medium 5s ease-in-out infinite; }
        @keyframes float-fast { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-40px); } }
        .animate-float-fast { animation: float-fast 3.5s ease-in-out infinite; }
        @keyframes float-cross { 0%, 100% { transform: translateY(0) rotate(-8deg); } 50% { transform: translateY(-18px) rotate(8deg); } }
        .animate-float-cross { animation: float-cross 6s ease-in-out infinite; }
      `}</style>
            </section>

            {/* Service Pillars as Cards */}
            <section className="w-full px-4 py-12">
                <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
                    {servicePillars.map((pillar, idx) => (
                        <div key={pillar.title} className={`group bg-gradient-to-br ${pillar.color} rounded-3xl shadow-2xl p-10 flex flex-col items-center text-center transition-transform duration-300 hover:-translate-y-2 hover:shadow-3xl cursor-pointer animate-fade-in`} style={{ animationDelay: `${0.2 + idx * 0.15}s` }}>
                            <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-white/80 shadow-lg transition-all duration-300 group-hover:bg-blue-50">
                                {pillar.icon}
                            </div>
                            <h2 className="mb-2 text-2xl font-bold text-lochmara-blue">{pillar.title}</h2>
                            <p className="mb-4 font-redhat text-gray-700">{pillar.desc}</p>
                            <ul className="mx-auto mb-4 max-w-xs list-inside list-disc text-left font-redhat text-sm text-gray-600">
                                {pillar.details.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                            {pillar.learn && <Link to={pillar.learn} className="mt-auto rounded-full bg-brand px-6 py-2 font-bold text-white shadow transition-transform duration-200 hover:scale-105 hover:bg-brand-green">Learn more</Link>}
                        </div>
                    ))}
                </div>
            </section>

            {/* Other Services Accordion */}
            <section className="w-full px-4 py-8">
                <div className="mx-auto max-w-5xl">
                    <button onClick={() => setShowOther(v => !v)} className="mb-6 rounded-full bg-brand px-8 py-3 text-lg font-bold text-white shadow transition-transform duration-200 hover:scale-105 hover:bg-brand-green">
                        {showOther ? 'Hide' : 'Show'} Other Services
                    </button>
                    {showOther && (
                        <div className="animate-fade-in grid grid-cols-1 gap-8 md:grid-cols-2">
                            {otherServices.map((cat, idx) => (
                                <div key={cat.title} className="flex flex-col rounded-2xl bg-white/90 p-8 shadow-lg">
                                    <h3 className="mb-2 text-xl font-bold text-congress-blue">{cat.title}</h3>
                                    <ul className="list-inside list-disc text-gray-700">
                                        {cat.details.map((item, i) => (
                                            <li key={i}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>
            {/* Call to Action Section */}
            <section className="flex w-full flex-col items-center bg-gradient-to-br from-blue-100 to-teal-50 px-4 py-12">
                <h2 className="mb-4 text-center font-ubuntu text-2xl font-bold text-congress-blue md:text-3xl">Take the Next Step</h2>
                <p className="mb-6 max-w-2xl text-center font-redhat text-lg text-gray-700">Let’s work together to build healthier communities.
                    Whether you need medical support, healthcare training, digital solutions, or partnership opportunities, PUREMEDIFY is ready to collaborate.</p>

            </section>

            {/* Quick Links */}
            <section className="w-full px-4 py-8">
                <div className="mx-auto flex max-w-5xl flex-wrap justify-center gap-4">
                    {quickLinks.map(link => (
                        <Link key={link.label} to={link.href} className="flex items-center rounded-full bg-lochmara-blue px-6 py-3 text-base font-bold text-white shadow transition-transform duration-200 hover:scale-105 hover:bg-brand-green">
                            {link.icon}{link.label}
                        </Link>
                    ))}
                </div>
            </section>


            {/* Call to Action Section */}
            <section className="flex w-full flex-col items-center  from-blue-100 to-teal-50 px-4 py-12">
                <h2 className="mb-4 text-center font-ubuntu text-2xl font-bold text-congress-blue md:text-3xl">Ready to Experience Our Services?</h2>
                <p className="mb-6 max-w-2xl text-center font-redhat text-lg text-gray-700">Contact us to learn more about our integrated solutions or to partner with us for a healthier, more empowered future.</p>
                <Link to="/contact" className="rounded-full bg-brand px-8 py-4 font-ubuntu text-lg font-semibold text-white shadow-lg transition-transform duration-200 hover:scale-105 hover:bg-brand-green">Contact Us</Link>
            </section>
        </div>
    );
};

export default Services;
